<div class="modal-header">
  <h4 class="modal-title">{{ isEditing ? "Edit" : "Add" }} Loads</h4>
</div>
<div class="modal-body">
  <dx-form [formData]="model" validationGroup="manualLoadValidationGroup" [colCount]="2">
    <dxi-item itemType="group">
      <dxi-item dataField="loadDate" editorType="dxDateBox" [isRequired]="true"></dxi-item>
      <dxi-item
        dataField="customerId"
        editorType="dxSelectBox"
        [editorOptions]="{ dataSource: customersDS, displayExpr: 'codeDisplayName', valueExpr: 'id', onValueChanged: customerChanged }"
        [label]="{ text: 'Customer' }"
        [isRequired]="true"
      ></dxi-item>
      <dxi-item dataField="job"></dxi-item>
      <dxi-item
        dataField="productId"
        editorType="dxSelectBox"
        [editorOptions]="{ dataSource: productsDS, displayExpr: 'partNumber', valueExpr: 'id', onValueChanged: productChanged }"
        [label]="{ text: 'Product' }"
        [isRequired]="true"
      ></dxi-item>
      <dxi-item dataField="truck"></dxi-item>
      <dxi-item dataField="ticketNumber" editorType="dxNumberBox" [editorOptions]="{ step: 0 }" [isRequired]="true"></dxi-item>

      @if(model.isHourly){
        <dxi-item dataField="startTime" editorType="dxDateBox" [editorOptions]="{ type: 'time', interval: 15, width:'150px' }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="endTime" editorType="dxDateBox" [editorOptions]="{ type: 'time', interval: 15, width:'150px' }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        } @if(!model.isHourly){
        <dxi-item dataField="loadCount" editorType="dxNumberBox" [editorOptions]="{ step: 0 }" [label]="{ text: '# of Loads' }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="1" message="Cannot be less than 1"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="weightPerLoad" editorType="dxNumberBox" [editorOptions]="{ format: { precision: 2 }, step: 0 }">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="0" message="Cannot be less than 0"></dxi-validation-rule>
        </dxi-item>
      }
      <dxi-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="range" [min]="0" message="Cannot be less than 0"></dxi-validation-rule>
      </dxi-item>
      <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"></dxi-item>


      <dxi-item [label]="{ text: 'Add Delivery' }">
        <div *dxTemplate>
          <dx-check-box [(value)]="model.hasDelivery" (onValueChanged)="deliveryCheckBoxChanged($event)"></dx-check-box>
        </div>
      </dxi-item>

      @if(model.hasDelivery){
        <dxi-item
          dataField="deliveryProductId"
          editorType="dxSelectBox"
          [editorOptions]="{ dataSource: deliveryProducts, valueExpr: 'id', displayExpr: 'partNumber' }"
          [label]="{ text: 'Delivery Product' }"
          [isRequired]="model.hasDelivery"
        ></dxi-item>
        <dxi-item dataField="deliveryPrice" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }">
          @if (model.hasDelivery) {
            <dxi-validation-rule type="required"></dxi-validation-rule>
          }
          @if (model.hasDelivery) {
            <dxi-validation-rule type="range" [min]="0" message="Cannot be less than 0"></dxi-validation-rule>
          }
        </dxi-item>
      }
    </dxi-item>
    <dxi-item itemType="group">
      <dxi-item itemType="empty"></dxi-item>
      <dxi-item [label]="{ text: 'Customer Type Price' }">
        <div *dxTemplate>
          <dx-number-box [value]="customerTypeLink?.price" [format]="{ type: 'currency', precision: 2 }" [readOnly]="true"></dx-number-box>
        </div>
      </dxi-item>
      <dxi-item [label]="{ text: 'R\'Mix Price' }">
        <div *dxTemplate>
          <dx-number-box [value]="mixStrengthLink?.price" [format]="{ type: 'currency', precision: 2 }" [readOnly]="true"></dx-number-box>
        </div>
      </dxi-item>
      <dxi-item [label]="{ text: 'Product Base Price' }">
        <div *dxTemplate>
          <dx-number-box [value]="product?.basePrice" [format]="{ type: 'currency', precision: 2 }" [readOnly]="true"></dx-number-box>
        </div>
      </dxi-item>
    </dxi-item>
  </dx-form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
